import { Box, FormControlProps } from '@mui/material';
import { useId } from 'react';
import { FieldContext } from './FieldContext';
export default function FormControl({children,error,disabled,required,fullWidth,sx,className,margin}:FormControlProps) {
    const id=useId();
    return <FieldContext.Provider value={{id,error,disabled,required}}><Box className={`spark-field-group d-flex flex-column ${fullWidth ? 'w-100' : ''} ${margin==='normal' ? 'mb-3' : ''} ${className || ''}`} sx={sx}>{children}</Box></FieldContext.Provider>;
}
